export default "__VITE_ASSET__DVxTfT0j__"